// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__RjLBK","layoutWrapper":"Layout_layoutWrapper__vi8Sa","contentWrapper":"Layout_contentWrapper__ldj9O"};